// This id is used to initialize the Meta Pixel tracking script
export const metaPixelId = '1081902691834097';
